import Dashboard from "./Dashboard-container";

/**
 * Export the top level component Dashboard-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default Dashboard;
